export default "__VITE_ASSET__5620e123__"